import { FOUNDATION } from 'config/features';
import { defineMessage } from 'react-intl';

export const USER_ROLES = {
  ADMIN: 'Admin',
  OPERATOR: 'Operator',
  MONITOR: 'Monitor',
  BILLING: 'Billing',
  DEPLOYER: 'Deployer',
  AGENT: 'Agent',
};

export const OWNER_ROLE = 'Owner';

export const FOUNDATION_OWNER_ORG = 'foundation';

export const USER_ROLES_LABELS = [
  { intl: defineMessage({ id: 'UserConfig-option-admin', defaultMessage: 'Admin' }), value: USER_ROLES.ADMIN },
  { intl: defineMessage({ id: 'UserConfig-option-operator', defaultMessage: 'Operator' }), value: USER_ROLES.OPERATOR },
  { intl: defineMessage({ id: 'UserConfig-option-monitor', defaultMessage: 'Monitor' }), value: USER_ROLES.MONITOR },
  { intl: defineMessage({ id: 'UserConfig-option-billing', defaultMessage: 'Billing' }), value: USER_ROLES.BILLING },
  { intl: defineMessage({ id: 'UserConfig-option-deployer', defaultMessage: 'Deployer' }), value: USER_ROLES.DEPLOYER },
  { intl: defineMessage({ id: 'UserConfig-option-agent', defaultMessage: 'Agent' }), value: USER_ROLES.AGENT },
];

export const isUserOwner = roles => {
  if (FOUNDATION) {
    return roles?.some(
      item => item.organizationDetails.name === FOUNDATION_OWNER_ORG && item.role === USER_ROLES.ADMIN
    );
  }
  return roles?.some(
    item => (item.organizationId === 1 || item.organizationId === '1') && item.role === USER_ROLES.ADMIN
  );
};

export const isUserAdmin = user => organizationId =>
  user?.roles?.some(item => item.organizationId === organizationId && item.role === USER_ROLES.ADMIN);
